module.exports = __webpack_public_path__ + "static/media/percentage.33c32545.svg";